module.exports = __webpack_public_path__ + "img/2.a83be0ac.jpg";